import { Button } from './ui/button';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { AlertCircle, XCircle } from 'lucide-react';
import { useBodyScrollLock } from '@/hooks/useBodyScrollLock';

interface CheckInConfirmDialogProps {
  isOpen: boolean;
  attendeeName: string;
  eventName: string;
  onConfirm: () => void;
  onCancel: () => void;
  isCheckingIn?: boolean;
  error?: string | null;
}

export const CheckInConfirmDialog = ({
  isOpen,
  attendeeName,
  eventName,
  onConfirm,
  onCancel,
  isCheckingIn = false,
  error = null,
}: CheckInConfirmDialogProps) => {
  useBodyScrollLock(isOpen);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-[var(--color-neutral-900)]">
            <AlertCircle className="h-5 w-5 text-[var(--color-warning-600)]" />
            Confirm Check-In
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          {error && (
            <div className="p-3 bg-red-50 border border-red-200 rounded-lg flex items-start gap-2">
              <XCircle className="h-4 w-4 text-red-600 mt-0.5 flex-shrink-0" />
              <p className="text-sm text-red-800">{error}</p>
            </div>
          )}

          <p className="text-[var(--color-neutral-700)]">
            Are you sure you want to check in <strong>{attendeeName}</strong> for the event <strong>{eventName}</strong>
            ?
          </p>
          <div className="flex gap-3 justify-end">
            <Button variant="outline" onClick={onCancel} disabled={isCheckingIn} className="min-w-[100px]">
              Cancel
            </Button>
            <Button variant="success" onClick={onConfirm} disabled={isCheckingIn} className="min-w-[150px]">
              {isCheckingIn ? 'Checking in...' : 'Confirm Check-In'}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
